import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit'
import liveReducer from './fluxLiveSlice'

export const store = configureStore({
  reducer: {
    live: liveReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action>
